import _ from "lodash";

import Skeleton from "components/Skeleton";
import Text from "components/Text";

import { ITable, ITableWithImportTable } from "entities/TableStorage/sdk";

export interface IHeaderSubTitle {
  table: ITable | ITableWithImportTable | undefined;
}

const HeaderSubTitle = ({ table }: IHeaderSubTitle) =>
  _.isNil(table) ? (
    <Skeleton />
  ) : (
    <>
      {!_.isNil(table?.deal_company_import_table) && (
        <>
          <Text component="span" fontWeight={700} variant="text3">
            Synced range:
          </Text>{" "}
          <Text component="span" variant="text3">
            {table.deal_company_import_table.sheet_name}, Columns{" "}
            {table.deal_company_import_table.column_start}-
            {table.deal_company_import_table.column_end}, Rows{" "}
            {table.deal_company_import_table.row_start}-
            {table.deal_company_import_table.row_end}
          </Text>
        </>
      )}
    </>
  );

export default HeaderSubTitle;
